import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function baseArea(query) {
    return request({
        url: '/business/basearea/queryList',
        method: 'get',
        params: query
    })
}

// 数据字典
export function type(id) {
    return request({
        url: `/system/dict/data/type/${id}`,
        method: 'get',
    })
}

// 煤焦钢矿产业链(首页无权限)
export function chainList(query) {
    return request({
        url: '/business/metatron/chain/noAuth/stellChainPrice',
        method: 'get',
        params: query
    })
}

// 首页列表
export function indexList(query) {
    return request({
        url: `/aromatics/metatron/price/noAuth/getRealTimePrice`,
        method: 'get',
        params: query
    })
}

// 价格预测列表（首页）
export function forecastNoAuthList(query) {
    return request({
        url: `/business/forecast/noAuth/list`,
        method: 'get',
        params: query
    })
}

// 价格预测列表
export function forecastList(query) {
    return request({
        url: `/business/forecast/queryPriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情
export function forecastDetail(id) {
    return request({
        url: `/business/forecast/getPriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表钢铁
export function steelForecastList(query) {
    return request({
        url: `/business/forecast/querySteelPriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情钢铁
export function steelForecastDetail(id) {
    return request({
        url: `/business/forecast/getSteelPriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表铁矿石
export function ironstoneForecastList(query) {
    return request({
        url: `/business/forecast/queryStonePriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情铁矿石
export function ironstoneForecastDetail(id) {
    return request({
        url: `/business/forecast/getStonePriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表焦煤
export function coalForecastList(query) {
    return request({
        url: `/coal/forecast/queryPriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情焦煤
export function coalForecastDetail(id) {
    return request({
        url: `/coal/forecast/getPriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表石油苯
export function oilBenzeneForecastList(query) {
    return request({
        url: `/aromatics/forecast/queryOilBenzenePriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情石油苯
export function oilBenzeneForecastDetail(id) {
    return request({
        url: `/aromatics/forecast/getOilBenzenePriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表己内酰胺
export function caprolactamForecastList(query) {
    return request({
        url: `/aromatics/forecast/queryCaprolactamPriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情己内酰胺
export function caprolactamForecastDetail(id) {
    return request({
        url: `/aromatics/forecast/getCaprolactamPriceForecastById/${id}`,
        method: 'get',
    })
}

// 价格预测列表煤焦油（首页）
export function zetarForecasNoAuthtList(query) {
    return request({
        url: `/material/forecast/noAuth/list`,
        method: 'get',
        params: query
    })
}

// 价格预测列表煤焦油
export function zetarForecastList(query) {
    return request({
        url: `/material/forecast/queryPriceForecastList`,
        method: 'get',
        params: query
    })
}

// 价格预测详情煤焦油
export function zetarForecastDetail(id) {
    return request({
        url: `/material/forecast/getPriceForecastById/${id}`,
        method: 'get',
    })
}

// 碳材料产业链大图
export function bigChainList(query) {
    return request({
        url: '/material/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 单点登陆
export function getTokenLogin(query) {
    return request({
        url: '/auth/singleLogin',
        method: 'get',
        params: query
    })
}

// 获取是否具有权限
export function getPreAuthorizeFlag(id) {
    return request({
        url: '/business/provide/noAuth/getPreAuthorizeFlag/' + id,
        method: 'get',
    })
}

